import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IconButtonComponent } from './icon-button.component';



@NgModule({
  declarations: [IconButtonComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule
  ],
  exports: [IconButtonComponent]
})
export class IconButtonModule { }
